import {WEDDING_OPINION_00} from "./weddings/wedding_00/Wedding00";


export const OPINIONS_RECEIVED = [
    WEDDING_OPINION_00
];
